import { render, staticRenderFns } from "./DotIcon.vue?vue&type=template&id=a901a1d6&scoped=true"
var script = {}
import style0 from "./DotIcon.vue?vue&type=style&index=0&id=a901a1d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a901a1d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a901a1d6')) {
      api.createRecord('a901a1d6', component.options)
    } else {
      api.reload('a901a1d6', component.options)
    }
    module.hot.accept("./DotIcon.vue?vue&type=template&id=a901a1d6&scoped=true", function () {
      api.rerender('a901a1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/DotIcon.vue"
export default component.exports